import {
  Component,
  ChangeDetectionStrategy,
  InputSignal,
  input,
} from '@angular/core';
import { ModelForm } from '../../models';
import { PaginationForm } from '../../models/pagination.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent {
  readonly FIRST_PAGE = 1;
  readonly DEFAULT_ITEMS_PEER_PAGE = 1;

  total: InputSignal<number> = input<number>();
  paginationSizeList: InputSignal<number[]> = input<number[]>([
    this.DEFAULT_ITEMS_PEER_PAGE,
    20,
    50,
    100,
  ]);

  paginationFormGroupRef: InputSignal<FormGroup<ModelForm<PaginationForm>>> =
    input<FormGroup<ModelForm<PaginationForm>>>(
      new FormGroup({
        pageNumber: new FormControl(this.FIRST_PAGE),
        pageSize: new FormControl(this.DEFAULT_ITEMS_PEER_PAGE),
      })
    );

  inputPage = this.FIRST_PAGE;
  page = this.FIRST_PAGE;

  paginate(page: number): void {
    if (page >= this.FIRST_PAGE && page <= this.total()) {
      this.paginationFormGroupRef().controls.pageNumber.setValue(page);
      this.page = page;
      this.inputPage = page;
    } else {
      this.inputPage = this.page;
    }
  }
}
